<mat-toolbar color="primary">
  <span>
    <img ngSrc="/assets/logo.png" alt="Santander" height="67" width="190" [priority]="true">
  </span>
  <span class="fill-remaining-space"></span>
  <button mat-button (click)="goToApplications()" matTooltip="Aplicaciones">
    <mat-icon aria-hidden="false">assignment</mat-icon>
  </button>
  <button mat-button [matMenuTriggerFor]="userMenu" *ngIf="userDetails" matTooltip="Perfil">
    <mat-icon aria-hidden="false" aria-label="User">person</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <mat-list role="list">
      <mat-list-item role="listitem">
        <button mat-menu-item (click)="goToApplications()">
          <mat-icon aria-hidden="false">assignment</mat-icon>
          <span>Aplicaciones</span>
        </button>
      </mat-list-item>
    </mat-list>
  </mat-menu>
  <mat-menu #userMenu="matMenu">
    @if (userDetails) {
      <div class="user-details">
        {{ userDetails.firstName }} {{ userDetails.lastName }}
        @if (claims) {
          ({{ claims["broker"] }})
        }
      </div>
    }
    <button mat-menu-item *ngIf="userDetails" (click)="doLogout()">
      <mat-icon aria-hidden="false">logout</mat-icon>
      <span>Salir</span>
    </button>
    <button mat-menu-item *ngIf="!userDetails" (click)="doLogin()">
      <mat-icon aria-hidden="false">login</mat-icon>
      <span>Ingresar</span>
    </button>
  </mat-menu>
  <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="userDetails">
    <mat-icon>more_vert</mat-icon>
  </button>
</mat-toolbar>
